import {setStore} from '../../../../src/utility/setStore'
export default {
    SET_VALUES(state,data) {
        state.list = data;
        //setStore('moduleName','Key',value)
        setStore('website','values,list',data)
    },
    SET_CURRENT_VALUE(state,data) {
        state.currentValue = data;
        //setStore('moduleName','Key',value)
        setStore('website','values,currentValue',data)
    },
    SET_STORIES(state,data) {
        state.list = data;
        //setStore('moduleName','Key',value)
        setStore('website','stories,list',data)
    },
    SET_CURRENT_STORY(state,data) {
        state.currentStory = data;
        //setStore('moduleName','Key',value)
        setStore('website','stories,currentStory',data)
    },
};
